import React from "react";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import Tokens from "../../../../store/tokens";
import Tooltip from "../Tooltip";

interface Props {
  inSideDrawer?: boolean;
  onClick?: () => void;
}

const Login: React.FC<RouteComponentProps & Props> = (props) => {
  const { getRedirectLink } = Tokens.useContainer();

  const clickLogin = () => {
    getRedirectLink(`${props.location.pathname}${props.location.search}`);
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <Link to="/get-request-token" className="tooltipParent" onClick={clickLogin}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`h-6 w-6 ml-3 stroke-current ${props.inSideDrawer ? "defaultText" : "text-white"}`}
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
        />
      </svg>
      <Tooltip>Login to TMDb</Tooltip>
    </Link>
  );
};

export default withRouter(Login);
